var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { TextField } from '@material-ui/core';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import Icon from '@thingos/design-icons/web';
import React, { useMemo, useState } from 'react';
import { Tag } from './Tag';
function isNewOption(option) {
    return option.inputValue != null;
}
export function AddTag(_a) {
    var tags = _a.tags, onTagSelect = _a.onTagSelect, onCreate = _a.onCreate, createText = _a.createText, rest = __rest(_a, ["tags", "onTagSelect", "onCreate", "createText"]);
    var filter = useMemo(function () { return createFilterOptions(); }, []);
    var _b = useState(false), expanded = _b[0], setExpanded = _b[1];
    if (!expanded) {
        return (React.createElement(Tag, __assign({ onClick: function () {
                setExpanded(true);
            } }, rest),
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    width: '100%',
                } },
                React.createElement(Icon, { kind: "ui/add", height: "16", width: "16" }))));
    }
    else {
        return (React.createElement(Tag, __assign({ onDelete: function () { return setExpanded(false); } }, rest),
            React.createElement(Autocomplete, { id: "add-tag-autocomplete", disableClearable: true, options: tags, onClose: function () { return setExpanded(false); }, onChange: function (_, option) {
                    if (typeof option === 'string') {
                        onCreate({ name: option });
                    }
                    else if (isNewOption(option)) {
                        onCreate({ name: option.inputValue });
                    }
                    else {
                        onTagSelect(option);
                    }
                    setExpanded(false);
                }, filterOptions: function (options, params) {
                    var filtered = filter(options, params);
                    // Suggest the creation of a new value if non empty input and not the same as available option
                    if (params.inputValue !== '' &&
                        filtered.findIndex(function (option) { return option.name === params.inputValue; }) === -1) {
                        filtered.push({
                            inputValue: params.inputValue,
                            name: createText(params.inputValue),
                        });
                    }
                    return filtered;
                }, getOptionLabel: function (option) {
                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                        return option;
                    }
                    // Add "xxx" option created dynamically
                    if (isNewOption(option)) {
                        return option.inputValue;
                    }
                    // Regular option
                    return option.name;
                }, renderOption: function (tag) { return tag.name; }, selectOnFocus: true, clearOnBlur: true, freeSolo: true, handleHomeEndKeys: true, style: { width: 200 }, open: true, renderInput: function (params) { return React.createElement(TextField, __assign({ placeholder: "Placeholder", autoFocus: true }, params)); } })));
    }
}
